import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { GeneralHelper } from '@shared/helpers';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private http = inject(HttpClient);

    private readonly API_URL = `${environment.apiUrl}/`;

    get(path: string, params = {}): Observable<any> {
        return this.http.get(`${this.API_URL}${path}`, { params: params }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    put(path: string, body = {}): Observable<any> {
        const trimmedBody = GeneralHelper.trimStrings(body);

        return this.http.put(`${this.API_URL}${path}`, trimmedBody).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    post(path: string, body = {}, params = {}, responseType: 'json' | 'text' = 'json'): Observable<any> {
        const trimmedBody = GeneralHelper.trimStrings(body);

        return this.http
            .post(`${this.API_URL}${path}`, trimmedBody, { params: params, responseType: responseType as any })
            .pipe(
                catchError(error => {
                    if (error.error === 'login_required') {
                        window.location.reload();
                    }
                    return throwError(error);
                })
            );
    }

    delete(path: string, body = {}): Observable<any> {
        return this.http.delete(`${this.API_URL}${path}`, { body }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    patch(path: string, body = {}): Observable<any> {
        const trimmedBody = GeneralHelper.trimStrings(body);

        return this.http.patch(`${this.API_URL}${path}`, trimmedBody).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    download(path: string): Observable<any> {
        return this.http.post(`${this.API_URL}${path}`, {}, { responseType: 'blob' }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }
}
